module.exports = __webpack_public_path__ + "static/media/arrow_anim.de8f3f9a.webm";